import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Input } from "../../components/ui/input";
import { Panel, Pill, urgTone } from "./OfficeLayout";
import { api, titleize, shortDate } from "../../lib/api";

export const PIPELINE = ["QR_SCANNED_LINK_CLICKED", "LANDING_PAGE", "INTAKE_STARTED", "LEAD_CREATED", "INITIAL_TRIAGE", "INTAKE_IN_PROGRESS",
  "DOCUMENTS_REQUESTED", "DOCUMENTS_RECEIVED", "AI_REVIEW", "VERIFICATION_REQUIRED", "INTAKE_COMPLETED", "SPECIALIST_ASSIGNED", "SPECIALIST_CONTACTED",
  "OPTIONS_REVIEWED", "SOLUTION_SELECTED", "IN_PROCESS", "RESOLVED_CLOSED", "REFERRAL_ATTRIBUTION", "COMPENSATION_CONVERSION_RECORD"];

export const PartnerLeadTable = ({ leads }) => (
  <div className="overflow-x-auto"><table className="w-full text-xs" data-testid="partner-leads-table">
    <thead><tr className="text-left font-mono text-[10px] uppercase text-muted-foreground">{["Lead", "Date", "City/ZIP", "Stage", "Case", "Conversion", "Compensation"].map((h) => <th key={h} className="px-2 py-1.5">{h}</th>)}</tr></thead>
    <tbody>{leads.map((l) => (
      <tr key={l.id} className="border-t border-border"><td className="px-2 py-1.5 font-mono">{l.id}</td><td className="px-2">{shortDate(l.created_at)}</td><td className="px-2">{l.city || "—"} {l.zip}</td>
        <td className="px-2">{titleize(l.stage)}</td><td className="px-2">{l.case_status}</td><td className="px-2">{titleize(l.conversion_status)}</td><td className="px-2"><Pill tone="cyan">{titleize(l.compensation_status)}</Pill></td></tr>
    ))}{!leads.length && <tr><td colSpan={7} className="px-2 py-4 text-center text-muted-foreground">No leads yet</td></tr>}</tbody>
  </table></div>
);

export default function Leads() {
  const { user } = useOutletContext();
  const [leads, setLeads] = useState([]);
  const [stage, setStage] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/office/leads", { params: { stage: stage || undefined, q: q || undefined } }).then(({ data }) => setLeads(data)); }, [stage, q]);
  return (
    <div className="space-y-4" data-testid="leads-page">
      <h1 className="text-2xl font-bold">{user.role === "specialist" ? "My Assigned Cases" : "Leads & Cases"}</h1>
      <div className="flex flex-wrap gap-2">
        <Input data-testid="leads-search" placeholder="Search lead ID, name, address, ZIP, referral code" value={q} onChange={(e) => setQ(e.target.value)} className="h-9 max-w-sm" />
        <select data-testid="leads-stage-filter" value={stage} onChange={(e) => setStage(e.target.value)} className="h-9 rounded border border-border bg-background px-2 text-sm">
          <option value="">All stages</option>{PIPELINE.map((s) => <option key={s} value={s}>{titleize(s)}</option>)}
        </select>
      </div>
      <Panel>
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="leads-table">
            <thead><tr className="text-left font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
              {["Lead", "Homeowner", "Property", "Urgency", "Tracks", "Stage", "Referral", "Progress", "Flags", "Created"].map((h) => <th key={h} className="whitespace-nowrap px-2 py-1.5">{h}</th>)}</tr></thead>
            <tbody>{leads.map((l) => {
              const s = l.snapshot || {};
              return (
                <tr key={l.id} className="border-t border-border hover:bg-secondary/40">
                  <td className="px-2 py-2"><Link data-testid={`lead-link-${l.id}`} to={`/office/leads/${l.id}`} className="font-mono font-semibold text-primary hover:underline">{l.id}</Link></td>
                  <td className="px-2">{l.contact?.name || <span className="text-muted-foreground">Not provided</span>}</td>
                  <td className="max-w-[180px] truncate px-2">{l.property?.street ? `${l.property.street}, ${l.property.zip || ""}` : "—"}</td>
                  <td className="px-2"><Pill tone={urgTone(s.urgency)}>{s.urgency || "—"}{s.days_remaining !== null && s.days_remaining !== undefined ? ` ${s.days_remaining}d` : ""}</Pill></td>
                  <td className="px-2">{(s.tracks || []).map((t) => <span key={t} className="mr-1 text-muted-foreground">{titleize(t)}</span>)}</td>
                  <td className="whitespace-nowrap px-2">{titleize(l.stage)}</td>
                  <td className="px-2 font-mono">{l.referral?.code}</td>
                  <td className="px-2 font-mono">{l.progress || 0}%</td>
                  <td className="space-x-1 px-2">{l.duplicate && <Pill tone="yellow">Possible existing lead</Pill>}{s.open_conflicts > 0 && <Pill tone="orange">{s.open_conflicts} conflict</Pill>}{s.scam && <Pill tone="red">Scam risk</Pill>}</td>
                  <td className="whitespace-nowrap px-2">{shortDate(l.created_at)}</td>
                </tr>);
            })}{!leads.length && <tr><td colSpan={10} className="px-2 py-6 text-center text-muted-foreground">No leads match.</td></tr>}</tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
